import moment from 'moment';
import { BlockInterface } from '../interface/block.interface';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';

export class BlockServiceHelper {

  public static calculationMethodList = [
    {
      id: 1,
      description: 'Reference Turbine(s) - Production Data',
      managementAppName: 'REFERENCE_TURBINE',
      disabled: false
    },
    { id: 2, description: 'Power Curve', managementAppName: 'POWER_CURVE', disabled: false },
    {
      id: 3,
      description: 'Reference Turbine - Wind Speed',
      managementAppName: 'REFERENCE_POWER_CURVE',
      disabled: false
    },
    {
      id: 4,
      description: 'Neighbouring Windpark Data',
      managementAppName: 'NEIGHBOURING_WINDPARK_DATA',
      disabled: false
    },
    {
      id: 6,
      description: 'Predicted Theoretical Production',
      alternativeAppName: 'FORECAST_THEORETICAL_PRODUCTION',
      managementAppName: 'PREDICTED_THEORETICAL_PRODUCTION',
      disabled: false
    },
    { id: 5, description: 'Custom Input', managementAppName: '', disabled: false },
  ];

  public static mapLobookBlockResponse(blockData: any, timezoneService: TimezoneService) {
    /* Get settings for the default production losses calculation method */
    const defaultProductionLossMethod = blockData.data.turbines[0].productionLossMethod.production_loss_calculation;
    const turbineLogbookExport = blockData.data.turbines[0].turbineLogbookExport.turbineLogbookEntries;
    blockData.data.turbines[0].turbineLogbook.turbineLogbookEntries.forEach((block: any) => {
      const turbineExport = turbineLogbookExport.find(blockExport => blockExport?._id === block?._id);
      block.startTS = timezoneService.unApplyTzFromDate(block.startTS).valueOf();
      block.endTS = timezoneService.unApplyTzFromDate(block.endTS).valueOf();
      if (!block?.events) {
        block.events = [];
      }
      block.totalProductionLoss = Math.round(block.totalProductionLoss * 100) / 100;
      block.totalRevenueLoss = Math.round(block.totalRevenueLoss * 100) / 100;
      if (block.tcmLossesComment) {
        if (typeof block.tcmLossesComment === 'string') {
          block.tcmLossesComment = block.tcmLossesComment
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\t/g, '\\t');
          block.tcmLossesComment = JSON.parse(block.tcmLossesComment);
        } else {
          block.tcmLossesComment.message === ''
            ? (block.tcmLossesComment = { username: '', message: '', date: '', user_id: '' })
            : null;
        }
      }
      if (block.amLossesComment) {
        if (typeof block.amLossesComment === 'string') {
          block.amLossesComment = block.amLossesComment
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\t/g, '\\t');
          block.amLossesComment = JSON.parse(block.amLossesComment);
        } else {
          block.amLossesComment.message === ''
            ? (block.amLossesComment = { username: '', message: '', date: '', user_id: '' })
            : null;
        }
      }
      if (block.lossesMethod) {
        if (typeof block.lossesMethod === 'string') {
          try {
            block.lossesMethod = JSON.parse(block.lossesMethod)
          } catch {
            block.lossesMethod = '';
          }
        }
      } else {
        if (defaultProductionLossMethod) {
          const option = this.calculationMethodList.filter(
            (c) => c.managementAppName === defaultProductionLossMethod.calculation_method || c.alternativeAppName === defaultProductionLossMethod.calculation_method
          )[0].id;
          const subOption = defaultProductionLossMethod.method
            ? defaultProductionLossMethod.method === 'MANUFACTURER_POWERCURVE' ? 1 : defaultProductionLossMethod.method === 'NO_SUBMETHOD' ? 0 : 2
            : 0;
          block.lossesMethod = {
            selectedOption: option,
            selectedSuboption: subOption,
            selectedTurbines:
                option !== 4 ? defaultProductionLossMethod.references.map((r) => r._id) : [],
            selectedPark:
                option === 4 ? defaultProductionLossMethod.references.map((r) => r._id) : []
          };
        } else {
          block.lossesMethod = {
            selectedOption: 2,
            selectedSuboption: 1,
            selectedTurbines: [ block._id_turbine ],
            selectedPark: []
          };
        }
      }
      if(!block.lossesMethod) block.lossMethod = {} 
      block.lossesMethod.selectedProvider ??= defaultProductionLossMethod?.provider;
      if (block.log === '' && block.eventCode && block.eventDescription) {
        block.log = block.eventCode + '-' + block.eventDescription;
      }
      if (block._id_process === 'null') {
        block._id_process = null;
      }
      if (block.subBlocks) {
        const subBlock = [];
        block.subBlocksObject = [];
        block.subBlocks.forEach((s: any) => !!s && subBlock.push(JSON.parse(s)));
        block.subBlocksObject = subBlock;
      }
      if (block.blockActionsLog) {
        if (block.blockActionsLog[0] === '"') {
          block.blockActionsLog = block.blockActionsLog.slice(1, block.blockActionsLog.length - 1);
        }
        if (typeof block.blockActionsLog === 'string') {
          try {
            block.blockActionsLog = JSON.parse(block.blockActionsLog);
            block.blockActionsLog.actionFE = block.blockActionsLog.action + ' by ' + block.blockActionsLog.user + ' on ' +
                                            moment(block.blockActionsLog.date).format('DD MMM YYYY HH:mm');
          } catch {
            block.blockActionsLog = '';
          }
        }
      }
      if (block.controlroomAckLog && block.controlroomAckLog.length > 0) {
        const controlroomAckLog = [];
        block.controlroomAckLog.forEach((c: any) => !!c && controlroomAckLog.push(JSON.parse(c)));
        block.controlroomAckLog = controlroomAckLog;
      }
      if (block.controlroomTicketing && block.controlroomTicketing.length > 0) {
        const controlroomTicketing = [];
        block.controlroomTicketing.forEach((c: any) => !!c && controlroomTicketing.push(JSON.parse(c)));
        block.controlroomTicketing = controlroomTicketing;
      }
      if (block.controlroomTicketingLog && block.controlroomTicketingLog.length > 0) {
        const controlroomTicketingLog = [];
        block.controlroomTicketingLog.forEach((c: any) => !!c && controlroomTicketingLog.push(JSON.parse(c)));
        block.controlroomTicketingLog = controlroomTicketingLog;
      }
      block.startTSExport = timezoneService.unApplyTzFromDate(turbineExport?.startTS).valueOf();
      block.endTSExport = timezoneService.unApplyTzFromDate(turbineExport?.endTS).valueOf();
      if (turbineExport?.subBlocks) {
        block.subBlocksExport = turbineExport?.subBlocks;
        const subBlock = [];
        turbineExport?.subBlocks.forEach((s: any) => !!s && subBlock.push(JSON.parse(s)));
        block.subBlocksObjectExport = subBlock;
      }
    });
    return blockData;
  }

  public static mapParkLogbookResponse(blockData: any) {
    const defaultProductionLossMethodPerTurbine = blockData.data.parks[0].turbines;
    blockData.data.parks[0].parkLogbookLosses = blockData.data.parks[0].parkLogbookLosses.map((data) => {
      const block = JSON.parse(JSON.stringify(data));
      if (block.tcmLossesComment) {
        if (typeof block.tcmLossesComment === 'string') {
          block.tcmLossesComment = block.tcmLossesComment
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\t/g, '\\t');
          block.tcmLossesComment = JSON.parse(block.tcmLossesComment);
        } else {
          block.tcmLossesComment.message === ''
            ? (block.tcmLossesComment = { username: '', message: '', date: '', user_id: '' })
            : null;
        }
      }
      if (block.amLossesComment) {
        if (typeof block.amLossesComment === 'string') {
          block.amLossesComment = block.amLossesComment
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\t/g, '\\t');
          block.amLossesComment = JSON.parse(block.amLossesComment);
        } else {
          block.amLossesComment.message === ''
            ? (block.amLossesComment = { username: '', message: '', date: '', user_id: '' })
            : null;
        }
      }
      if (block.lossesMethod) {
        if (typeof block.lossesMethod === 'string') {
          try {
            block.lossesMethod = JSON.parse(block.lossesMethod)
          } catch {
            block.lossesMethod = '';
          }
        }
      } else {
        const turbineProdLossesMethod = defaultProductionLossMethodPerTurbine.filter(
          (t) => t.productionLossMethod._id === block._id_turbine
        )[0].productionLossMethod.production_loss_calculation;
        if (turbineProdLossesMethod) {
          const option = this.calculationMethodList.filter(
            (c) => c.managementAppName === turbineProdLossesMethod.calculation_method || c.alternativeAppName === turbineProdLossesMethod.calculation_method
          )[0].id;
          const subOption = turbineProdLossesMethod.method
            ? turbineProdLossesMethod.method === 'MANUFACTURER_POWERCURVE' ? 1 : 2
            : 0;
          block.lossesMethod = {
            selectedOption: option,
            selectedSuboption: subOption,
            selectedTurbines:
              option !== 4 ? turbineProdLossesMethod.references.map((tr) => tr._id) : [],
            selectedPark:
              option === 4 ? turbineProdLossesMethod.references.map((tr) => tr._id) : []
          };
        } else {
          block.lossesMethod = {
            selectedOption: 2,
            selectedSuboption: 1,
            selectedTurbines: [ block._id_turbine ],
            selectedPark: []
          };
        }
      }
      if (block.controlroomAckLog && block.controlroomAckLog.length > 0) {
        const controlroomAckLog = [];
        block.controlroomAckLog.forEach((c: any) => !!c && controlroomAckLog.push(JSON.parse(c)));
        block.controlroomAckLog = controlroomAckLog;
      }
      if (block.controlroomTicketing && block.controlroomTicketing.length > 0) {
        const controlroomTicketing = [];
        block.controlroomTicketing.forEach((c: any) => !!c && controlroomTicketing.push(JSON.parse(c)));
        block.controlroomTicketing = controlroomTicketing;
      }
      if (block.controlroomTicketingLog && block.controlroomTicketingLog.length > 0) {
        const controlroomTicketingLog = [];
        block.controlroomTicketingLog.forEach((c: any) => !!c && controlroomTicketingLog.push(JSON.parse(c)));
        block.controlroomTicketingLog = controlroomTicketingLog;
      }
      return block;
    });
    return blockData.data.parks[0];
  }

  public static mapTclassBlocksResponse(blockData: any) {
    const data = JSON.parse(JSON.stringify(blockData));
    data.data.parks[0].parkLogbook = data.data.parks[0].parkLogbook.map((block: any) => {
      // const block = JSON.parse(JSON.stringify(b));
      const defaultProductionLossMethod = block.turbine.productionLossMethod.production_loss_calculation;
      if (block.lossesMethod) {
        if (typeof block.lossesMethod === 'string') {
          try {
            block.lossesMethod = JSON.parse(block.lossesMethod)
          } catch {
            block.lossesMethod = '';
          }
        }
      } else {
        if (defaultProductionLossMethod) {
          const option = this.calculationMethodList.filter(
            (c) => c.managementAppName === defaultProductionLossMethod.calculation_method || c.alternativeAppName === defaultProductionLossMethod.calculation_method
          )[0].id;
          const subOption = defaultProductionLossMethod.method
            ? defaultProductionLossMethod.method === 'MANUFACTURER_POWERCURVE' ? 1 : 2
            : 0;
          block.lossesMethod = {
            selectedOption: option,
            selectedSuboption: subOption,
            selectedTurbines:
              option !== 4 ? defaultProductionLossMethod.references.map((r) => r._id) : [],
            selectedPark:
              option === 4 ? defaultProductionLossMethod.references.map((r) => r._id) : []
          };
        } else {
          block.lossesMethod = {
            selectedOption: 2,
            selectedSuboption: 1,
            selectedTurbines: [ block._id_turbine ],
            selectedPark: []
          };
        }
      }
      block.lossesMethod = JSON.stringify(block.lossesMethod);
      if (block.blockActionsLog) {
        if (block.blockActionsLog[0] === '"') {
          block.blockActionsLog = block.blockActionsLog.slice(1, block.blockActionsLog.length - 1);
        }
        if (typeof block.blockActionsLog === 'string') {
          try {
            block.blockActionsLog = JSON.parse(block.blockActionsLog);
            block.blockActionsLog.actionFE = block.blockActionsLog.action + ' by ' + block.blockActionsLog.user + ' on ' +
                                            moment(block.blockActionsLog.date).format('DD MMM YYYY HH:mm');
          } catch {
            block.blockActionsLog = '';
          }
        }
      }
      if (block.controlroomAckLog && block.controlroomAckLog.length > 0) {
        const controlroomAckLog = [];
        block.controlroomAckLog.forEach((c: any) => !!c && controlroomAckLog.push(JSON.parse(c)));
        block.controlroomAckLog = controlroomAckLog;
      }
      if (block.controlroomTicketing && block.controlroomTicketing.length > 0) {
        const controlroomTicketing = [];
        block.controlroomTicketing.forEach((c: any) => !!c && controlroomTicketing.push(JSON.parse(c)));
        block.controlroomTicketing = controlroomTicketing;
      }
      if (block.controlroomTicketingLog && block.controlroomTicketingLog.length > 0) {
        const controlroomTicketingLog = [];
        block.controlroomTicketingLog.forEach((c: any) => !!c && controlroomTicketingLog.push(JSON.parse(c)));
        block.controlroomTicketingLog = controlroomTicketingLog;
      }
      return block;
    });
    return data;
  }

  public static prepareBlockForSaving(block: BlockInterface, skipLossesAndCommentsParse?: boolean): BlockInterface {
    const savedBlock = JSON.parse(JSON.stringify(block));
    if (savedBlock?.userComment) {
      savedBlock.userComment = savedBlock?.userComment?.replace(/'/g, "`")
    }
    if (savedBlock?.tcmLossesComment && savedBlock?.tcmLossesComment?.message) {
      savedBlock.tcmLossesComment.message = savedBlock?.tcmLossesComment?.message?.replace(/'/g, "`")
    }
    if (savedBlock?.amLossesComment && savedBlock?.amLossesComment.message) {
      savedBlock.amLossesComment.message = savedBlock?.amLossesComment?.message?.replace(/'/g, "`")
    }
    if (savedBlock?.eventDescription) {
      savedBlock.eventDescription = savedBlock?.eventDescription?.replace(/'/g, "`")
    }
    if (!skipLossesAndCommentsParse) {
      savedBlock.amLossesComment.message
        ? (savedBlock.amLossesComment = JSON.stringify(savedBlock.amLossesComment))
        : (savedBlock.amLossesComment = '');
      savedBlock.tcmLossesComment.message
        ? (savedBlock.tcmLossesComment = JSON.stringify(savedBlock.tcmLossesComment))
        : (savedBlock.tcmLossesComment = '');
        savedBlock.lossesMethod
          ? (savedBlock.lossesMethod = JSON.stringify(savedBlock.lossesMethod))
          : (savedBlock.lossesMethod = '');
    }

    if (savedBlock.controlroomAckLog && savedBlock.controlroomAckLog.length > 0) {
      const controlroomAckLog = [];
      savedBlock.controlroomAckLog.forEach((c: any) => !!c && controlroomAckLog.push(JSON.stringify(c)));
      savedBlock.controlroomAckLog = Array.from(new Set(controlroomAckLog));
    }
    if (savedBlock.controlroomTicketing && savedBlock.controlroomTicketing.length > 0) {
      const controlroomTicketing = [];
      savedBlock.controlroomTicketing.forEach((c: any) => !!c && controlroomTicketing.push(JSON.stringify(c)));
      savedBlock.controlroomTicketing = Array.from(new Set(controlroomTicketing));
    }
    if (savedBlock.controlroomTicketingLog && savedBlock.controlroomTicketingLog.length > 0) {
      const controlroomTicketingLog = [];
      savedBlock.controlroomTicketingLog.forEach((c: any) => !!c && controlroomTicketingLog.push(JSON.stringify(c)));
      savedBlock.controlroomTicketingLog = Array.from(new Set(controlroomTicketingLog));
    }
    const deletedFields = [
      'turbine',
      'parkMaintain',
      'turbineMaintain',
      'tcuDescription',
      '__typename',
      'validToTS',
      'validFromTS',
      'isNewBlock',
      'active',
      'events',
      'eventCount',
      'customEventList',
      'paginatedEvents',
      'paginatedEventsIndex',
      'actualProduction',
      'theoreticalProduction',
      'loadingEvents',
      'eventsOutOfDate',
      'originalLog',
      'subBlocksObject',
      'toBeSaved',
      'selected',
      'open', 
      'wil',
      'wol',
      'processName'
    ];
    for (const field of deletedFields) {
      delete savedBlock[field];
    }

    return savedBlock;
  }
}

export const NonAckTClasses = ['T0', 'T6'];